import React, { FC, Fragment } from 'react';
import { useTranslation } from 'react-i18next';
import { Box, Theme, useMediaQuery, Typography } from '@mui/material';
import { MillingJob, MillingJobCopyReason, MillingJobStatus } from 'models/milling';

type MillingJobStatusChipProps = {
    job: MillingJob;
};
const MillingJobStatusChip: FC<MillingJobStatusChipProps> = ({ job }: MillingJobStatusChipProps) => {
    const { t: translate } = useTranslation(['milling-jobs', 'orders']);
    const isMobile = useMediaQuery((theme: Theme) => theme.breakpoints.down('lg'));

    const colorMap = {
        [MillingJobStatus.PROCESSING_FILES]: '#444',
        [MillingJobStatus.CREATED]: '#444',
        [MillingJobStatus.IN_PRODUCTION]: 'extra.main',
        [MillingJobStatus.FINISHED]: 'success.main',
        [MillingJobStatus.REDONE]: 'warning.main',
    };

    return (
        <Fragment>
            {isMobile ? (
                <Box
                    sx={{
                        width: 14,
                        height: 14,
                        borderRadius: 7,
                        backgroundColor: colorMap[job.status],
                    }}
                ></Box>
            ) : (
                <Fragment>
                    <Box>
                        <Typography
                            variant="body2"
                            sx={{
                                whiteSpace: 'nowrap',
                                overflow: 'hidden',
                                textOverflow: 'ellipsis',
                                fontWeight: 600,
                                color: colorMap[job.status],
                            }}
                        >
                            {translate(`milling-jobs:${job.status}`)}
                        </Typography>
                    </Box>
                    <Box>
                        {job.copyReason === MillingJobCopyReason.REDO && (
                            <Typography color="extra.dark" variant="caption">
                                {translate('milling-jobs:REDO')}
                            </Typography>
                        )}
                        {job.copyReason === MillingJobCopyReason.WARRANTY && (
                            <Typography color="extra.dark" variant="caption">
                                {translate('milling-jobs:WARRANTY_JOB')}
                            </Typography>
                        )}
                    </Box>
                </Fragment>
            )}
        </Fragment>
    );
};

export default MillingJobStatusChip;
